<template>
  <div class="index-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
      <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img src="../assets/images/LOGO.png" alt="農科院農業課程報名及查詢系統:回首頁" />
        </a>
      </h1>
      <main class="index-content">
        <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
        <h2 :class="!ms_ie?'index-h2':'index-h2-ie'">農科院</h2>
        <h3 :class="!ms_ie?'index-h3':'index-h3-ie'">農業課程報名及查詢系統</h3>
        <div class="btn-box">
          <a
            class="btn light-green"
            href="/Course/Index"
            title="課程報名"
            >課程報名</a
          >
          <a class="btn dark-green" href="/Course/ParticipantSearch" title="報名查詢"
            >報名查詢</a
          >
        </div>
      </main>
    </div>
    <Footer class="index-footer"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import BG from '../assets/images/BG_01.png';

export default {
  name: 'index',
  components: {
    Footer,
  },
  data() {
    return {
      BG,
      ms_ie: false,
    };
  },
  created() {
    const vm = this;
    const ua = window.navigator.userAgent;
    const oldIe = ua.indexOf('MSIE ');
    const newIe = ua.indexOf('Trident/');
    if ((oldIe > -1) || (newIe > -1)) {
      vm.ms_ie = true;
    }
  },
};
</script>

<style lang="scss" scoped>
#AC,#AU {
  color: transparent;
}

.index-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  // @media (max-width: 420px) {
  //   height: 100%;
  // }
}

.index-content {
  padding: 3.5rem;

  @media (max-width: 1024px) {
    padding: 10rem 3.5rem;
  }
  @media (max-width: 768px) {
    padding: 3.5rem;
  }

  @media (max-width: 767px) {
    padding: 1rem 0;
  }
  @media (max-width: 420px) {
    padding: 0 0 5rem 0;
  }
  @media (max-width: 375px) {
    padding: 0 0 10rem 0;
  }
  @media (max-width: 320px) {
    padding: 1rem 0;
  }

  p {
    font-size: 1.5rem;
    color: #767676;
    padding: 2.5rem 0;
    line-height: 1.5;
    letter-spacing: 8px;

    @media (max-width: 375px) {
      padding: 1.5rem 0;
    }
  }
}

.index-h2 {
  background: linear-gradient(to bottom, #dce6b0 0, #abccad 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 5.5rem;
  font-weight: bold;
  letter-spacing: 20px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.index-h2-ie {
  color: #abccad;
  font-size: 5.5rem;
  font-weight: bold;
  letter-spacing: 20px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.index-h3 {
  background: linear-gradient(to bottom, #7eb5ac 0, #5da3ab 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3.5rem;
  font-weight: bold;
  letter-spacing: 8px;
  margin-bottom: 2.5rem;
}

.index-h3-ie {
  color:  #5da3ab;
  font-size: 3.5rem;
  font-weight: bold;
  letter-spacing: 8px;
  margin-bottom: 2.5rem;
}

.btn-box {
  display: flex;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }

  a:first-child {
    margin-right: 1.5rem;

    @media (max-width: 767px) {
      margin-right: 0;
      margin-bottom: 1.5rem;
    }
  }
}

.btn {
  display: block;
  color: #fff;
  border-radius: 50rem;
  padding: 1rem 3.5rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  font-size: 1.5rem;
  letter-spacing: 5px;
  text-decoration: none;

  &.light-green {
    background-color: #4dba95;
  }

  &.dark-green {
    background-color: #8bb75f;
  }
}

.index-footer {
  position: absolute;
  bottom: 0;
  right: 10%;
  @media (max-width: 1366px) {
      position: initial;
  }
}
</style>
